import React, { useState } from 'react';
import { Importer, ImporterField } from 'react-csv-importer';
import { addShopifySrikandiTag } from '../../../../API';

export interface AddtagRow {
  email: string;
  name: string;
  level: string;
  birth_month: string;
  new_tag_shopify: string;
  shopify_id: string;
}

const CSVImporterAddShopifyTag = () => {
  const [rows, setRows] = useState<AddtagRow[]>([]);

  const handleDataRows = (r: any[]) => {
    const sanitised: AddtagRow[] = r.map((e) => ({
      email: e.email,
      name: e.name,
      level: e.level,
      birth_month: e.birth_month,
      new_tag_shopify: e.new_tag_shopify,
      shopify_id: e.shopify_id,
    }));
    setRows((rows) => rows.concat(sanitised));
  };

  const handleComplete = async () => {
    // run importer

    console.log('rows', rows);
    await addShopifySrikandiTag(rows);
  };

  return (
    <Importer
      dataHandler={(rows, { startIndex }) => {
        handleDataRows(rows);
      }}
      defaultNoHeader={false} // optional, keeps "data has headers" checkbox off by default
      restartable // optional, lets user choose to upload another file when import is complete
      onComplete={handleComplete}
      /*onStart={({ file, preview, fields, columnFields }) => {
        // optional, invoked when user has mapped columns and started import
        prepMyAppForIncomingData();
      }}

      onClose={({ file, preview, fields, columnFields }) => {
        // optional, if this is specified the user will see a "Finish" button after import is done,
        // which will call this when clicked
        goToMyAppNextPage();
      }}*/

      // CSV options passed directly to PapaParse if specified:
      // delimiter={...}
      // newline={...}
      // quoteChar={...}
      // escapeChar={...}
      // comments={...}
      // skipEmptyLines={...}
      // delimitersToGuess={...}
      // chunkSize={...} // defaults to 10000
      // encoding={...} // defaults to utf-8, see FileReader API
    >
      <ImporterField name="email" label="Email" />
      <ImporterField name="name" label="name" />
      <ImporterField name="level" label="level" />
      <ImporterField name="birth_month" label="birth month" />
      <ImporterField name="new_tag_shopify" label="add new tag shopify" />
      <ImporterField name="shopify_id" label="Shopify ID" />
    </Importer>
  );
};

export default CSVImporterAddShopifyTag;
